import { Button, ButtonProps } from '@mui/material';

export interface TextConfirmButtonProps extends Omit<ButtonProps, 'onClick'> {
  /**
   * Mandatory callback function triggered when the user clicks the button to reset data.
   */
  handleConfirm: (e?: React.MouseEvent) => void;
  /**
   * Optional text text display inside the button.
   * @default "Elimina"
   */
  label?: string;
}

/**
 * A reusable, styled action button designed for confirm action on active table filters or form states.
 * Inherits all standard Material-UI Button properties except `onClick` (replaced by `handleConfirmDelete`).
 *
 * @component
 */
export const TextConfirmButton = ({
  handleConfirm: handleConfirm,
  label = 'Elimina',
  sx,
  ...rest
}: TextConfirmButtonProps) => {
  return (
    <Button
      {...rest}
      onClick={handleConfirm}
      variant="contained"
      disableElevation
      autoFocus
      fullWidth
      sx={{
        textTransform: 'none',
        fontWeight: 600,
        borderRadius: 2.5,
        py: 1,
        bgcolor: 'error.main',
        '&:hover': {
          bgcolor: 'error.dark'
        },
        ...sx
      }}>
      {label}
    </Button>
  );
};
